<template>
    <div>
      <table>
        <tr>
          <th>Reason</th>
          <th>Description</th>
        </tr>
        <tr>
          <td>Low Purchase Price with Discounts</td>
          <td>You're purchasing the property at a discounted price. With a Bumiputera discount of RM 36,250 and a developer rebate of RM 32,625, your net price comes down significantly to RM 293,625. This means you're already saving money upfront.</td>
        </tr>
        <tr>
          <td>Loan Structure</td>
          <td>The loan amount matches the net price, so you're financing the entire purchase price. Additionally, the loan interest rate of 4.1% is relatively low, which is favorable for your cash flow over the long term.</td>
        </tr>
        <tr>
          <td>Affordable Monthly Instalments</td>
          <td>Your monthly instalment is RM 1,318, which is quite reasonable considering the purchase price. This allows you to comfortably manage your cash flow without putting too much strain on your finances.</td>
        </tr>
        <tr>
          <td>Cash Back</td>
          <td>You're receiving RM 10,000 cash back, which can be used to cover various expenses associated with the property purchase or to bolster your cash reserves.</td>
        </tr>
        <tr>
          <td>Rental Income</td>
          <td>Generating rental income of RM 2,000 per month provides you with a steady stream of cash flow. This rental income exceeds your monthly instalment by RM 682, meaning you have surplus cash flow every month.</td>
        </tr>
        <tr>
          <td>Prime Location</td>
          <td>The property's proximity to an international school and a medical university enhances its rental appeal significantly. Many families with children attending the international school or students studying at the medical university will seek accommodation nearby for convenience and accessibility.</td>
        </tr>
        <tr>
          <td>High Demand</td>
          <td>The presence of these educational institutions ensures a steady demand for rental properties in the area. Students, faculty members, and staff often prefer to live close to their place of study or work, which means you'll have a large pool of potential tenants to choose from.</td>
        </tr>
        <tr>
          <td>Stable Tenant Base</td>
          <td>Tenants affiliated with educational institutions tend to be reliable and stable renters. They often sign longer leases, providing you with consistent rental income and reducing the risk of frequent vacancies.</td>
        </tr>
        <tr>
          <td>Potential for Premium Rent</td>
          <td>Properties located near prestigious educational institutions typically command higher rental rates due to the perceived value of convenience and proximity. This means you can potentially charge a premium rent, further boosting your cash flow and return on investment.</td>
        </tr>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PositiveCashFlowReasons'
  }
  </script>
  
  <style>
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  th, td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  th {
    background-color: #f2f2f2;
  }
  </style>
  